import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.getStudentListClassChange.loading;
export const selectErrorMessage = (state: RootState) =>
  state.getStudentListClassChange.error;
export const studentListClassChangeResponse = (state: RootState) =>
  state.getStudentListClassChange.studentListClassChangeResponse;
